import {
    VerificationVm,
    DocumentDetailVm,
} from '../../../utils/api';
import VerificationForm from './VerificationForm';

interface OwnProps {
    verification?: VerificationVm;
    document?: DocumentDetailVm;
    onClose: () => void;
    onSuccess: (result: VerificationVm) => void;
}

export type Props = OwnProps;

export default VerificationForm;
